import React, {FC} from "react"
import {applyPriceFormatter, CurrencyConfiguration} from "@next/utils"
import {connector} from "./connect"
import {FacetName, FacetList} from "./components"
import {FilterPrice} from "../../models/Filter"
import {TextModel} from "../../models/Text"

type CollaspedPriceFilterProps = {
    priceFilter: FilterPrice
    locale: string
    realm: string
    text: TextModel
    globalPriceFormattingConfig: CurrencyConfiguration
}

export const CollaspedPriceFilter: FC<CollaspedPriceFilterProps> = ({
    priceFilter,
    locale,
    realm,
    text,
    globalPriceFormattingConfig,
}) => (
    <>
        <FacetName variant="h5" data-testid="plp-collasped-price-name">
            {priceFilter.name}:
        </FacetName>
        <FacetList data-testid="plp-collasped-price-info">
            {text.pages.collaspedFilters.from}{" "}
            {applyPriceFormatter({
                globalPriceFormattingConfig,
                minPrice: priceFilter.selectedMin,
                maxPrice: priceFilter.selectedMax,
                currencyCode: priceFilter.currencyCode,
                locale,
                realm,
            })}
        </FacetList>
    </>
)

export default connector(CollaspedPriceFilter)
